<template>
  <fragment>
    <tr>
      <td>{{manager.Profile.Name}}</td>
      <td>{{item.Name}}</td>
      <td v-show="!isMobile">
        <span v-if="isMoneyVisible">${{item.Amount | amountFormat}}</span>
        <span v-else>-</span>
      </td>
      <td v-show="!isMobile">
        <span v-if="isMoneyVisible">${{totalIssuedBonus | amountFormat}}</span>
        <span v-else>-</span>
      </td>
      <td v-show="!isMobile">{{item.Remark}}</td>
      <td>
        <v-tooltip
          top
          v-if="canEditTask"
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn
                v-if="canEditTask"
                color="primary "
                fab
                dark
                x-small
                @click.stop="editItem"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </span>
          </template>
          <span v-if="!isProjectFinished">編輯任務</span>
          <span v-else>專案已結束</span>
        </v-tooltip>

        <v-tooltip
          top
          v-if="canEditTask"
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn
                v-if="canEditTask"
                color="accent"
                fab
                dark
                x-small
                :disabled="!canDeleteThisTask"
                @click.stop="confirmDeleteItem"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </span>
          </template>
          <span v-if="isProjectFinished">專案已結束</span>
          <span v-else-if="!canDeleteThisTask">無法刪除，日誌已審核獎金</span>
          <span v-else>刪除任務</span>
        </v-tooltip>

        <div style="float: right">
          <v-tooltip
            top
            v-if="canEditTask"
          >
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn
                  v-if="canEditTask"
                  :disabled="isProjectFinished"
                  color="primary "
                  dark
                  small
                  @click.stop="addTaskWorkingItem"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </span>
            </template>
            <span v-if="!isProjectFinished">新增工作</span>
            <span v-else>專案已結束</span>
          </v-tooltip>

          <v-btn
            v-if="workingItems.length"
            color="primary"
            dark
            small
            class="ml-1 mr-1"
            @click.stop="exportExcel(workingItems)"
          >
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>

          <v-icon
            v-if="workingItems.length"
            v-show="!isExpanded"
            @click.stop="isExpanded = true ; isShowTaskWorkingItems = true"
          >mdi-chevron-down</v-icon>
          <v-icon
            v-if="workingItems.length"
            v-show="isExpanded"
            @click.stop="isExpanded = false"
          >mdi-chevron-up</v-icon>
        </div>
      </td>
    </tr>
    <tr v-show="isExpanded && workingItems.length">
      <td colspan="6">
        <task-working-item-table :task="item" :is-exporting="isExporting" v-if="isShowTaskWorkingItems"/>
      </td>
    </tr>

    <task-working-item-addedit-dialog
      v-model="isShowTaskWorkingItemAddeditDialog"
      :editing-id="-1"
      :task-id="item.ID"
    />
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
import TaskWorkingItemTable from "./project-dialog-task-working-item-table.vue";
import TaskWorkingItemAddeditDialog from "@/ui/project/task/task-working-item-addedit-dialog.vue";
import { hoursFormat } from '@/data/filters/formatter.js';
import XLSXSaver from "@/data/excel/xlsx-saver.js";
import XMLGenerator from "@/data/excel/xml-generator-task-working-items-in-project-task.js";

export default {
  mixins: [filterMixin],
  components: { TaskWorkingItemTable, TaskWorkingItemAddeditDialog },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isExpanded: false,
    isShowTaskWorkingItemAddeditDialog: false,
    isShowTaskWorkingItems: false, // 顯示工作日誌效能差，延遲載入
    isExporting: false, // 匯出，匯出時隱藏編輯按鈕
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    manager() {
      return this.users.find(o => o.ID == this.item.ManagerID);
    },
    workingItems() {
      return this.taskWorkingItems.filter(o => o.TaskID == this.item.ID);
    },
    project() {
      return this.projects.find(o => o.ID == this.item.ProjectID) || {};
    },
    isProjectFinished() {
      return ["未得標", "已結案", "已完成"].includes(this.project.Status);
    },
    totalIssuedBonus() {
      return this.workingItems.reduce(
        (sum, o) => sum + (o.BonusReleasedAt ? o.Bonus : 0),
        0
      );
    },
    canDeleteThisTask() {
      // 找到已經審核的taskWorkingItem
      return (
        this.taskWorkingItems
          .filter(o => o.TaskID == this.item.ID)
          .findIndex(o => o.Status == "獎金發放中" || o.Status == "已完成") < 0
      );
    },
    isMoneyVisible () {
      return this.myLevel >= 10 || this.item.ManagerID == this.me.ID
    },
    ...mapGetters(["users", "canEditTask", "taskWorkingItems", "projects", "myLevel", "me"])
  },
  methods: {
    // 專案頁面-任務頁籤-點選某個任務展開的工作日誌
    exportExcel(taskWorkingItems) {
      // var datas = taskWorkingItems.map(o => ({
      //   'date': o.Date,
      //   'user-name': this.users.find(u => u.ID == o.UserID).Profile.Name,
      //   'content': o.Content,
      //   'bonus': o.Bonus || o.Budget,
      //   'hours': hoursFormat(o.ActualHours, o.ExtraHours),
      //   'status': o.Status,
      //   'bonus-issuer-name': (this.users.find(o => o.ID == o.BonusIssuerID) || { Profile: {} }).Profile.Name || '',
      //   'issued-at': o.IssuedAt,
      //   'isMoneyVisible': this.isMoneyVisible || o.UserID == this.me.ID,
      // }));
      // let result = XMLGenerator.generate(this, datas);

      var fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        `傳動ERP-[${this.project.Name}]-[${this.item.Name}]-工作明細匯出`
      );
      if (!fileName) {
        return window.alert("請輸入檔案名稱");
      }

      let theadID = `thead-task-working-items-in-task-${this.item.ID}-in-project-${this.project.ID}`;
      this.isExpanded = true;
      this.isExporting = true;
      this.isShowTaskWorkingItems = true;
      this.$nextTick(() => {
        let result = XMLGenerator.generate(theadID, fileName);
        XLSXSaver.saveAs(result, fileName);
        this.isExporting = false;
      });
    },
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Name || "") + "」?")) return;
      this.$emit("remove", this.item);
    },
    addTaskWorkingItem() {
      this.isShowTaskWorkingItemAddeditDialog = true;
    }
  }
};
</script>
